import { streetApi } from "src/config/axios";

const swrFetcher = async (url: string) => {
    return streetApi.get(url).then((response) => {
        return response.data;
    });
};

export default swrFetcher;
